import 'ui-core/components/accordion/js/accordion';

let accordion = UX.accordion;
accordion.on.toggle.single = function ($this) {
    let state;

    // This to solve accordion issue in full-page-database-selection widget
    var $accordionContent;
    if ($this.parent().hasClass('expandable-box')) {
        $accordionContent = $this.parent().find('.accordion__content');
    } else {
        $accordionContent = $this.next('.accordion__content');
    }
    // *** -=-=-=-=-=-=-=-=-=-=-=-=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=- *** //

    if (typeof $this.attr('data-content-target') !== 'undefined') {
        const contentTarget = $this.attr('data-content-target');
        $accordionContent = $(contentTarget);
    }
    $accordionContent.slideToggle(200, function () {
        if ($this.parent().hasClass('article-accordion')) {
            $('.article-row-left').height('auto');
            accordion.isStickyBody = state;
        }
    });
    $this.toggleClass('js--open');

    const $wrapper = $this.closest('.expandable-accordion');

    state = !($this.attr('aria-expanded') === 'true');
    $this.attr('aria-expanded', state);
    const accordionExpandedSingle = $.Event('accordion:expandedSingle');
    $(document).trigger(accordionExpandedSingle, [$this, $accordionContent]);
    if ($wrapper.length) accordion.on.checkExpandAll($this, state, $wrapper);
};
